export default (...args: any[]) => [...args].filter(Boolean).join(" ");
